import { ActivityMetadataModel } from '../../../api/api';
import { ActivityCategories } from '../Models/ActivityConstants';
import { FlowEdge } from '../Models/GraphModel';
import { isAgentToolTransition } from './AgentToolGraph';

/** Tools and agent services run before their owner's response variables are assigned. */
export function isInvocationScopeEdge(edge: FlowEdge, target?: ActivityMetadataModel): boolean {
	return isAgentToolTransition(edge)
		|| target?.categories?.includes(ActivityCategories.AGENT_SERVICE) === true
		|| target?.category === ActivityCategories.AGENT_SERVICE;
}
